import React, { useEffect, useState } from 'react';
import { Table, Td, Th, Thead, Tr } from '../managedITServices/components/css';
import request from '../../../utils/request';
import ValidateLoader from '../../../UI/validateLoader';
import Service from './components/service';
import { GroupOverlayCenter, GroupOverlayInner } from './components/css';
import Fee from './components/fee';
import { managedDetectionResponse } from '../../../utils/constant';

const ManagedDetectionResponse = () => {
  const [productCatalogQuantities, setProductCatalogQuantities] = useState([
    {
      serviceId: '',
      id: '',
      isRequired: false,
      name: '',
      note: '',
      productCatalogPricing: {
        id: '',
        quantityId: '',
        cost: 0,
        onetimePrice: 0,
        operationType: 'ADD'
      }
    }
  ]);
  const [
    managedDetectionResponseData,
    setManagedDetectionResponseData
  ] = useState(
    {
      offeringId: '',
      id: '', //ServiceId
      name: '',
      productCatalogQuantities
    }
  );
  const [feeData, setFeeData] = useState({
    id: '',
    offeringId: '',
    name: '',
    amount: 0
  });
  const [savingData, setSavingData] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [offeringId, setOfferingId] = useState(null);
  const [serviceId, setServiceId] = useState(null);

  const fetchFee = async offering => {
    if (offering) {
      const responseFee = await request.get(
        `/productCatalog/offerings/${offering}/fees`
      );
      if (responseFee.data[0]) {
        const { name, amount, id } = responseFee.data[0];
        setFeeData({
          ...feeData,
          name,
          amount,
          id,
          offeringId
        });
      }
    }
  };

  const saveManagedDetectionResponseData = data => {
    const mdrData = data.find(
      item => item.id === 6 && item.name === managedDetectionResponse
    );
    setOfferingId(mdrData.id);
    fetchFee(mdrData.id);
    setServiceId(mdrData.ServicesInOffering[0].id);
    const myData = mdrData.ServicesInOffering[0];
    setManagedDetectionResponseData(myData);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await request.get('/productCatalog');

        saveManagedDetectionResponseData(
          response.data[0].productCatalogOfferings
        );
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);


  return isLoading ? (
    <ValidateLoader
      message="Please wait request is In progress...."
      isFormStep={isLoading}
    />
  ) : (
    <>
      {savingData && (
        <GroupOverlayCenter>
          <GroupOverlayInner>
            <ValidateLoader
              message="Please wait request is In progress...."
              isFormStep={savingData}
            />
          </GroupOverlayInner>
        </GroupOverlayCenter>
      )}

      {managedDetectionResponseData && (
        <Service
          key={serviceId}
          offeringId={offeringId}
          quantityData={
            managedDetectionResponseData.productCatalogQuantities.length > 0
              ? managedDetectionResponseData.productCatalogQuantities[0]
              : productCatalogQuantities[0]
          }
          serviceIndex={0}
          setSavingData={setSavingData}
          managedDetectionResponseData={managedDetectionResponseData}
          setManagedDetectionResponseData={setManagedDetectionResponseData}
        />
      )}

      <Table>
        <Thead>
          <Tr>
            <Th width="40%">{managedDetectionResponse}</Th>
            <Th width="45%"></Th>
            {/* <Th width="30%"></Th> */}
            <Th width="15%">Fee</Th>
            {/* <Th width="10%">Price</Th> */}
          </Tr>
        </Thead>
        <tbody>
          {managedDetectionResponseData && (
            <Fee
              serviceId={serviceId}
              quantityData={productCatalogQuantities[0]}
              offeringId={offeringId}
              serviceIndex={0}
              setSavingData={setSavingData}
              managedDetectionResponseData={managedDetectionResponseData}
              setManagedDetectionResponseData={setManagedDetectionResponseData}
              feeData={feeData}
              setFeeData={setFeeData}
            />
          )}
        </tbody>
      </Table>
    </>
  );
};

export default ManagedDetectionResponse;
